import { HexColor } from "@mapmycustomers/shared/types/AnyColor";

const gradient = ["#4A90E2", "#32CD32", "#F3F315", "#FF6F1B", "#FF0000"] as HexColor[];

export default gradient;
